import { render, staticRenderFns } from "./statsBagagisteWidget.vue?vue&type=template&id=e9d2774a&scoped=true"
import script from "./statsBagagisteWidget.vue?vue&type=script&lang=js"
export * from "./statsBagagisteWidget.vue?vue&type=script&lang=js"
import style0 from "./statsBagagisteWidget.vue?vue&type=style&index=0&id=e9d2774a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d2774a",
  null
  
)

export default component.exports